'use client';
import { useEffect, useState } from 'react';

const getMatchesForQuery = (query: string) => {
  if (typeof window === 'undefined' || !('matchMedia' in window)) {
    return false;
  }

  return window.matchMedia(query).matches;
};

export function useMediaQuery(query: string) {
  const [matches, setMatches] = useState(() => getMatchesForQuery(query));

  useEffect(() => {
    if (typeof window === 'undefined' || !('matchMedia' in window)) return;

    const mql = window.matchMedia(query);
    const listener = (e: MediaQueryListEvent) => setMatches(e.matches);

    if (mql.addEventListener) {
      mql.addEventListener('change', listener);
      return () => mql.removeEventListener('change', listener);
    } else {
      // Safari < 14 fallback
      mql.addListener(listener);
      return () => mql.removeListener(listener);
    }
  }, [query]);

  return matches;
}
